import { RaFilterPanelState } from '../types';

export function raFilterPanelToHash(fpState: RaFilterPanelState): string {
  const keyCount = Object.keys(fpState).length;
  if (keyCount !== 2) {
    throw Error(
      'Developer, raFilterPanelToHash(), the filter panel has expanded from having just 2 properties, update this hashing function to include the new properties'
    );
  }

  return `ra-fp-hash-${fpState.activityRange}-${fpState.fraudType}`
    .toLowerCase()
    .trim();
}
